/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var NetConnectRssIcon20Light = forwardRef('NetConnectRssIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M8.606 5.673a10 10 0 0 0-4.082-.662.5.5 0 0 1-.047-.999 11 11 0 0 1 11.51 11.512.5.5 0 1 1-.998-.047 10 10 0 0 0-6.383-9.804Z" }),
        React.createElement("path", { d: "M6.701 10.298a5 5 0 0 0-2.156-.277.5.5 0 1 1-.091-.996 6 6 0 0 1 6.521 6.52.5.5 0 0 1-.996-.09 5 5 0 0 0-3.278-5.157Z" }),
        React.createElement("path", { d: "M5 16a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" })));
});
